import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import { Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import { RedTheme } from 'common/global';
import { NUMBER_ARRAY } from 'common/global/constants';
import { getDecodedBearerToken } from 'common/authentication/authToken';
import { useScreen } from 'common/hooks/useScreen';
import { isLocalStorageKeyExistDefined } from 'TAP/utils/commonMethods';

export const NavigationMenu = () => {
  const screen = useScreen();
  const [userRole, setUserRole] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const tabsRef = useRef(null);
  const handleTabIndexChange = (_event, newValue) => {
    setCurrentTabIndex(newValue);
  };
  let redtheme = RedTheme;
  const tabIndexThree = 3;
  const [navLinks, setNavLinks] = useState([]);
  const userDetails = localStorage.getItem('userDetails');
  const getLoggedInUserDetails = useSelector((state) => state.tapUserDetailsRd);
  const [isNavMenuReady, setNavMenuReady] = useState(false);
  const delegateSwitchRes = useSelector((state) => state?.delegateUserRd?.delegateSwitchRes);
  const isLoadingDelegateSwitch = useSelector((state) => state?.delegateUserRd?.isLoadingDelegateSwitchRes);

  useEffect(() => {
    if (
      getLoggedInUserDetails &&
      Object.keys(getLoggedInUserDetails)?.length > NUMBER_ARRAY.zero &&
      getLoggedInUserDetails.userDetails?.data[NUMBER_ARRAY.zero]
    ) {
      setNavMenuReady(true);
    }
  }, [getLoggedInUserDetails]);

  useEffect(()=> {
    if(tabsRef.current){
      tabsRef.current.updateIndicator();
      tabsRef.current.updateScrollButtons();
    }
  },[currentTabIndex])

  useEffect(() => {
    if (!isLoadingDelegateSwitch && delegateSwitchRes && Object.hasOwn(delegateSwitchRes, 'isDelegateSwitch')) {
      if (delegateSwitchRes?.isDelegateSwitch) {
        setIsAdmin(false);
      } else if (!delegateSwitchRes?.isDelegateSwitch) {
        manageAdminView();
      }
    } else {
      if (isLocalStorageKeyExistDefined('delegateProfileSwitched') && localStorage.getItem('delegateProfileSwitched') !== '[object Object]') {
        const delegateObj = JSON.parse(localStorage.getItem('delegateProfileSwitched'));
        delegateObj?.isDelegateSwitch ? setIsAdmin(false) : manageAdminView();
      }
    }
  }, [delegateSwitchRes, isLoadingDelegateSwitch])

  useEffect(() => {
    const parseUserDetails = userDetails ? JSON.parse(userDetails) : '';
    /**This code block will execute when we change delegate */
    let delegateObj = {isDelegateSwitch: false};
    if (isLocalStorageKeyExistDefined('delegateProfileSwitched') && localStorage.getItem('delegateProfileSwitched') !== '[object Object]') {
      delegateObj = JSON.parse(localStorage.getItem('delegateProfileSwitched'));
    }
    /**the condition will staisfy always if we don't choose delegate for switching
     * on the case of delegate & self switch logic will aplly from delegate useeffect on top
     */
    if(!delegateSwitchRes?.isDelegateSwitch && (delegateObj && !delegateObj.isDelegateSwitch)){
      manageAdminView();
    }
    if (parseUserDetails && Object.keys(parseUserDetails)?.length > NUMBER_ARRAY.zero) {
      setUserRole(parseInt(parseUserDetails?.user_role));
      prepareNavList(parseInt(parseUserDetails?.user_role));
    } else {
      setUserRole(NUMBER_ARRAY.one);
      prepareNavList(NUMBER_ARRAY.one);
    }
  }, [userDetails]);

  const prepareNavList = (currUserRole) => {
    let navLinksArr = []
    if (!currUserRole || currUserRole === NUMBER_ARRAY.zero) return;
    if (currUserRole === NUMBER_ARRAY.two || currUserRole === NUMBER_ARRAY.three) {
      navLinksArr = [
        { name: 'My Performance', path: '/' },
        { name: `My Team's Performance`, path: '/myorganisation' },
        { name: 'Training Plan View', path: '/trainingview' },
        { name: 'Role Profile', path: '/curriculumAssignmentRequest' }
      ];
    } else {
      navLinksArr = [
        { name: 'My Performance', path: '/' },
        { name: 'Training Plan View', path: '/trainingview' },
        { name: 'Role Profile', path: '/curriculumAssignmentRequest' }
      ];
    }
    if (process.env.REACT_APP_FEATURE_TOGGLE_ROLEPROFILE && process.env.REACT_APP_FEATURE_TOGGLE_ROLEPROFILE === 'OFF') {
      navLinksArr = navLinksArr.filter((linkItem) => linkItem?.name !== 'Role Profile');
    }
    
    setNavLinks(navLinksArr);
  };

  const manageAdminView = () => {
    const decodedBearerToken = getDecodedBearerToken();
    if (
      decodedBearerToken &&
      decodedBearerToken?.roles &&
      decodedBearerToken?.roles?.length > NUMBER_ARRAY.zero
    ) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }

  const handleNavigate = function (path) {
    window.location.href = process.env.REACT_APP_REDIRECT_URI_TAP + path;
  };

  let handleRefreshNavState = (userCurrRole) => {
    const isUserRoleOne = userCurrRole && userCurrRole === NUMBER_ARRAY.one;
    if (isUserRoleOne) {
      switch (window.location.pathname) {
        case '/TAP/':
          setCurrentTabIndex(NUMBER_ARRAY.zero);
          break;
        case '/TAP/trainingview':
          setCurrentTabIndex(NUMBER_ARRAY.one);
          break;
        case '/TAP/curriculumAssignmentRequest':
          setCurrentTabIndex(NUMBER_ARRAY.two);
          break;
        case '/TAP/adminview':
          setCurrentTabIndex(tabIndexThree);
          break;
        default:
          setCurrentTabIndex(NUMBER_ARRAY.zero);
          break;
      }
    }
    if (!isUserRoleOne) {
      switch (window.location.pathname) {
        case '/TAP/':
          setCurrentTabIndex(NUMBER_ARRAY.zero);
          break;
        case '/TAP/myorganisation':
          setCurrentTabIndex(NUMBER_ARRAY.one);
          break;
        case '/TAP/trainingview':
          setCurrentTabIndex(NUMBER_ARRAY.two);
          break;
        case '/TAP/curriculumAssignmentRequest':
          setCurrentTabIndex(tabIndexThree);
          break;
        case '/TAP/adminview':
          setCurrentTabIndex(NUMBER_ARRAY.four);
          break;
        default:
          setCurrentTabIndex(NUMBER_ARRAY.zero);
          break;
      }
    }
  };

  useEffect(() => {
    handleRefreshNavState(userRole);
  }, [userRole]);

  return (
    <>
      <Box
        data-testid='nav'
        component='nav'
        className='tap-appbar-header2'
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: {
            xs: '0px 10px',
            sm: '0px 10px',
            md: '0px 42px',
            lg: '0px 72px',
            xl: '0px 72px',
          },
          height: '48px',
          background: redtheme.palette.box.white,
          marginTop: '1px',
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px',
          fontFamily: '"JohnsonDisplay-Bold"',
        }}
      >
        <Box sx={{ width: '100%' }}>
            <Tabs
              value={currentTabIndex}
              onChange={handleTabIndexChange}
              action={tabsRef}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              TabIndicatorProps={{
                sx: {
                  height: '3px',
                  borderRadius: '3px',
                  fontFamily: '"JohnsonDisplay-Bold"',
                },
              }}
              sx={{
                minHeight: '49px',
                fontFamily: '"JohnsonDisplay-Bold"',
                color: redtheme.palette.fontColor.black_gray,
                '& .Mui-selected': {
                  fontWeight: 700,
                  fontSize: '16px',
                  color: `${redtheme.palette.fontColor.black_gray} !important`,
                },
              }}
              aria-label='TAP Navigation'
            >
            {isNavMenuReady &&
              userRole !== NUMBER_ARRAY.zero &&
              navLinks?.length > NUMBER_ARRAY.zero &&
              navLinks?.map((link, index) => (
                <Tab
                  key={index}
                  label={link?.name}
                  data-testid={link?.name}
                  textColor='blue'
                  onClick={() => handleNavigate(link?.path)}
                  sx={{
                    textTransform: 'none',
                    borderBottom: 3,
                    borderColor: 'divider',
                    fontSize: screen.isTablet ? '14px !important' : '16px !important',
                    minHeight: '49px',
                    fontFamily: '"JohnsonText-Medium"',
                    lineHeight: screen.isDesktop ? '16px' : null
                  }}

                />
              ))}
              {isNavMenuReady && isAdmin && (
                <Tab
                  label={'Administrative View'}
                  data-testid={'Administrative View'}
                  textColor='blue'
                  onClick={() => handleNavigate('/adminview')}
                  sx={{
                    textTransform: 'none',
                    borderBottom: 3,
                    borderColor: 'divider',
                    fontSize: '16px !important',
                    minHeight: '49px',
                    fontFamily: '"JohnsonText-Medium"',
                    lineHeight: '16px'
                  }}
                />
              )}
            </Tabs>
        </Box>
      </Box>
    </>
  );
};
